import axios from "axios";
import { useSelector } from "react-redux";
import { REACT_APP_MIRUM_SERVER_BASE_URL } from "config";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "redux/slices/auth";

function useAPI({ useAdminPrefix }) {
  const user = useSelector((state) => state.user);
  const tempSessionId = useSelector((state) => state.auth.tempSessionId);
  const history = useHistory();
  const dispatch = useDispatch();
  let baseURL = REACT_APP_MIRUM_SERVER_BASE_URL + "/api";
  useAdminPrefix = useAdminPrefix || false;
  if (useAdminPrefix) {
    baseURL = baseURL + "/admin";
  }

  const BASE_CONFIG = {
    withCredentials: true,
    headers: { tempSessionId: tempSessionId },
  };

  const handleError = (e) => {
    console.error("e", e);
    if (e?.response?.status === 403) {
      console.log("logout");
      dispatch(logout());
      history.push("/login");
    }
  };

  const get = async (url, config) => {
    console.log("user state", user);
    url = baseURL + url;
    config = config || {};
    config = { ...BASE_CONFIG, ...config };
    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      handleError(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  const post = async (url, body, config, interceptHandleError) => {
    url = baseURL + url;
    config = config || {};
    config = { ...BASE_CONFIG, ...config };
    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.post(url, body, config);
      return response.data;
    } catch (e) {
      interceptHandleError ? interceptHandleError(e) : handleError(e);
      return null;
    } finally {
      console.log("Done with API Call");
    }
  };

  const put = async (url, body, config) => {
    url = baseURL + url;
    config = config || {};
    config = { ...BASE_CONFIG, ...config };
    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.put(url, body, config);
      return response.data;
    } catch (e) {
      handleError(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  const del = async (url, config) => {
    url = baseURL + url;
    config = config || {};
    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.delete(url, config);
      return response.data;
    } catch (e) {
      handleError(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  return {
    API: {
      get,
      post,
      put,
      del,
    },
  };
}

export default useAPI;
